// extracted by mini-css-extract-plugin
export var modal = "_v7-0";
export var table = "_v7-1";